import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterReducerState } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { selectRouteData } from './store/router/selectors';
import { UserSettingsService } from './modules/shared/services/user-settings.service';
import * as fromAuth from './store/auth';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {
  user$ = this.store.select(fromAuth.selectUser);
  isImpersonated$ = this.store.select(fromAuth.selectIsImpersonated);

  constructor(
    private store: Store<{
      router: RouterReducerState;
    }>,
    title: Title,
    private settingsService: UserSettingsService,
    private swUpdate: SwUpdate,
    private snackbar: MatSnackBar,
  ) {
    settingsService.localise();
    this.subscribeToUpdate();
    store.select(selectRouteData).subscribe(data => {
      if (data && data.title) {
        title.setTitle(data.title);
      }
    });
  }

  finishImpersonation() {
    if (confirm('Finish impersonation session?')) this.store.dispatch(fromAuth.finishImpersonation());
  }

  subscribeToUpdate() {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates.pipe(filter(e => e.type === 'VERSION_READY')).subscribe(e => {
      this.settingsService.importantPopupShown$.next(true);
      this.snackbar
        .open('New version available', 'Update now', { duration: 10000 })
        .afterDismissed()
        .subscribe(x => {
          this.settingsService.importantPopupShown$.next(false);
          if (x.dismissedByAction) this.swUpdate.activateUpdate().then(() => window.location.reload());
        });
    });
  }
}
